<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>Total win to loss ratio</b-card-title>
    </b-card-header>
    <b-card-body class="d-flex justify-content-center align-items-center">
      <div v-if="loading">
        <div class="d-flex align-items-center justify-content-center">
          <b-skeleton
            class="rounded-circle mr-0"
            width="150px"
            height="140px"
          ></b-skeleton>
        </div>
        <div class="d-flex align-items-center justify-content-center mt-1">
          <b-skeleton width="40px" height="15px" class="mx-50"></b-skeleton>
          <b-skeleton width="40px" height="15px" class="mx-50"></b-skeleton>
        </div>
      </div>
      <div
        v-else-if="
          analytics &&
          analytics.win_to_loss_ratio &&
          (analytics.win_to_loss_ratio.win || analytics.win_to_loss_ratio.loss)
        "
      >
        <doughnut-chart
          :chartData="chartData"
          :colors="['#2CD889', '#FA4B68']"
          :labels="['win', 'loss']"
          height="120px"
          width="120px"
        />
      </div>
      <template v-else>
        <div class="d-flex justify-content-center h-100 new-alert">
          <div
            class="mt-2"
            style="
              border-radius: 100px;
              height: 115px;
              width: 115px;
              border: 23px solid rgb(45 45 53 / 44%);
            "
          > </div> 
        </div>
      </template>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BSkeleton,
  BAlert,
} from "bootstrap-vue";
import DoughnutChart from "@/views/components/doughnut-chart/DoughnutChart.vue";

export default {
  components: {
    DoughnutChart,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BSkeleton,
    BAlert,
  },
  props: {
    analytics: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    analytics(val) {
      this.donutChart.series = [
        val.win_to_loss_ratio.win,
        val.win_to_loss_ratio.loss,
      ];
    },
  },
  data() {
    return {
      donutChart: {
        series: [],
      },
    };
  },
  computed: {
    chartData() {
      return [
        this.analytics.win_to_loss_ratio.win,
        this.analytics.win_to_loss_ratio.loss,
      ];
    },
  },
};
</script>

<style></style>
